import React, { FC } from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { observer } from 'mobx-react-lite';
import { Box, FormControl, InputLabel, MenuItem, styled } from '@mui/material';

const MenuItemStyled = styled(MenuItem)({
  color: '#58585A',
});

interface BookingsDropdownProps {
  selectedValue?: string;
  handleChange?: (event: SelectChangeEvent) => void;
  availableYears: number[];
}

const BookingsDropdown: FC<BookingsDropdownProps> = observer(props => {
  const { selectedValue, handleChange, availableYears } = props;

  return (
    <Box>
      <FormControl sx={{ width: 200 }}>
        <InputLabel id="">Jahr</InputLabel>
        <Select
          id=""
          sx={{ color: '#58585A' }}
          value={selectedValue}
          label="Jahr"
          onChange={handleChange}
        >
          {availableYears.map(year => (
            <MenuItemStyled key={year} value={year}>
              {year}
            </MenuItemStyled>
          ))}
          <MenuItemStyled value={0}>Kein Filter</MenuItemStyled>
        </Select>
      </FormControl>
    </Box>
  );
});

export default BookingsDropdown;
